import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(customParseFormat)

// Dayjs doesn't support getting the current time in a specific timezone as a Date object
export const getCurrentTimeInSpecificTimezone = (specificTimezone: string | undefined) => {
  const currentTimeInSpecificTimezone = dayjs().tz(specificTimezone || dayjs.tz.guess())

  return new Date(
    currentTimeInSpecificTimezone.year(),
    currentTimeInSpecificTimezone.month(),
    currentTimeInSpecificTimezone.date(),
    currentTimeInSpecificTimezone.hour(),
    currentTimeInSpecificTimezone.minute(),
    currentTimeInSpecificTimezone.second(),
    currentTimeInSpecificTimezone.millisecond(),
  )
}

export const isPastCurrentTime = (
  specificDate: string | undefined,
  specificTimezone: string | undefined,
) => {
  if (!specificDate || !specificTimezone) return true
  return dayjs(specificDate).isBefore(getCurrentTimeInSpecificTimezone(specificTimezone))
}

export const DATE_FORMATS = [
  'YYYY-MM-DDTHH:mm:ss', // ISO format
  'YYYY-MM-DD',
  'MM/DD/YYYY',
  'DD-MM-YYYY',
] as const

export const looksLikeDate = (val: string): boolean =>
  DATE_FORMATS.some((format) => dayjs(val, format, true).isValid())

export default dayjs
